import React from "react";

/**
 * One primary KPI (40px value) and up to three secondary ones, plus the
 * "Highest average severity / Most frequent" style lists for PMS and Cravings.
 *
 * @param {Object} props
 * @param {Object} props.primary
 * @param {Array<Object>} props.secondary
 * @param {Array<{title: string, scope: string, items: Array<{name: string, txt: string}>}>} props.lists
 */
const KpiStrip = ({ primary, secondary, lists }) => (
  <div className="bg-white border border-[#ECECEC] rounded-[12px] px-[22px] py-[20px] flex flex-col gap-[18px]">
    <div className="flex">
      <div className="flex-[1.4] flex flex-col gap-[5px] pr-[22px] min-w-0">
        <span className="text-[12px] font-bold text-[#8a6a58]">{primary.label}</span>
        <span className="flex items-baseline gap-[5px]">
          <span className="text-[40px] font-bold tracking-[-0.03em] leading-none">{primary.value}</span>
          <span className="text-[14px] text-[#8a8a8a]">{primary.unit}</span>
        </span>
        <span className="text-[12px] text-[#6b6b6b]">{primary.scope}</span>
        <span className="text-[12px] font-semibold" style={{ color: primary.noteFg }}>
          {primary.note}
        </span>
      </div>
      {secondary.map((k) => (
        <div key={k.label} className="flex-1 flex flex-col gap-[5px] px-[20px] border-l border-[#F1ECE8] min-w-0">
          <span className="text-[12px] font-bold text-[#8a6a58]">{k.label}</span>
          <span className="flex items-baseline gap-[4px]">
            <span className="text-[24px] font-bold tracking-[-0.02em] leading-[1.1]">{k.value}</span>
            <span className="text-[12px] text-[#8a8a8a]">{k.unit}</span>
          </span>
          <span className="text-[12px] text-[#6b6b6b]">{k.scope}</span>
          <span className="text-[11px]" style={{ color: k.noteFg, fontWeight: k.noteW }}>
            {k.note}
          </span>
        </div>
      ))}
    </div>
    {lists.length > 0 && (
      <div className="grid grid-cols-2 gap-[24px] pt-[16px] border-t border-[#F1ECE8]">
        {lists.map((l) => (
          <div key={l.title} className="flex flex-col gap-[8px]">
            <span className="text-[12px] font-bold text-[#3a3a3a]">
              {l.title} <span className="font-normal text-[#8a8a8a]">· {l.scope}</span>
            </span>
            <div className="flex gap-[8px] flex-wrap">
              {l.items.map((i) => (
                <span key={i.name} className="flex gap-[8px] items-baseline px-[11px] py-[7px] rounded-[8px] bg-[#FAF7F5] text-[13px]">
                  <span className="font-semibold">{i.name}</span>
                  <span className="text-[#6b6b6b] tabular-nums">{i.txt}</span>
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default KpiStrip;
